"use strict";module.exports=typeof Bun=="function"&&Bun&&typeof Bun.version=="string";